import React from "react";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Policy() {
  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", paddingBottom: "80px" }}>
      {/* Clean White Header Banner */}
      <div
        style={{
          background: "#ffffff",
          color: "#0f172a",
          padding: "120px 0 50px 0",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div className="container">
          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              color: "#64748b",
              fontSize: "0.9rem",
              fontWeight: 600,
              textDecoration: "none",
              marginBottom: "20px",
            }}
          >
            <ArrowLeft size={16} /> Back to EMIBOOK Home
          </Link>

          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                background: "rgba(37, 99, 235, 0.1)",
                color: "#2563eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ShieldCheck size={24} />
            </div>
            <h1
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)",
                fontWeight: 800,
                color: "#0f172a",
                margin: 0,
              }}
            >
              Privacy Policy & Terms
            </h1>
          </div>
          <p style={{ color: "#64748b", fontSize: "1.05rem", maxWidth: "680px", margin: 0 }}>
            Learn how EMIBOOK collects, utilizes, and protects your information across our website and mobile application services.
          </p>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="container" style={{ marginTop: "40px" }}>
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div
              className="white-card"
              style={{
                borderRadius: "24px",
                padding: "40px",
                color: "#334155",
                lineHeight: 1.75,
              }}
            >
              <section style={{ marginBottom: "32px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  1. Policy Summary
                </h3>
                <p>
                  This Privacy Policy (“Policy”) describes the manner in which EMIBOOK website at <strong>www.EMIBOOK.in</strong> (the “Site”), and our mobile Application, as well as all related websites, networks, applications, and other services provided by <strong>S R R Enterprise</strong> (collectively, together with the Site, and the mobile Application our “Service”), gather information from you on the Service, how we use and disclose such information, and the steps we take to protect such information.
                </p>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  2. Information We Collect
                </h3>
                <h5 style={{ color: "#0f172a", fontWeight: 700, fontSize: "1.05rem", marginTop: "14px", marginBottom: "8px" }}>
                  A. User-Provided Information
                </h5>
                <p>
                  When you use the Service, we may collect information about you, including your name, first name and last name, email address, mobile phone number, geographic area, or business preferences, and we may link this information with other information about you. You provide us with information when you register for an account, record loan schedules, send customer service-related requests, or interact with our mobile application.
                </p>

                <h5 style={{ color: "#0f172a", fontWeight: 700, fontSize: "1.05rem", marginTop: "14px", marginBottom: "8px" }}>
                  B. Cookies and Automatically Collected Information
                </h5>
                <p>
                  When you use the Service, we may send session, preference, and security cookies to your device. We also automatically record certain information from your device, including your IP address, device ID, application logs, crash reporting, and analytical data to improve system reliability and security.
                </p>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  3. How We Use the Information We Collect
                </h3>
                <p>We use information collected through the Service to:</p>
                <ul style={{ paddingLeft: "20px", display: "flex", flexDirection: "column", gap: "8px" }}>
                  <li>Operate, maintain, enhance, and provide all features of the EMIBOOK EMI and loan management service.</li>
                  <li>Understand and analyze usage trends to improve product stability and release helpful features.</li>
                  <li>Communicate with you for administrative support, subscription renewals, and service notifications.</li>
                  <li>Generate digital transaction receipts and maintain tamper-proof loan ledgers for authorized lenders.</li>
                </ul>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  4. Disclosure and Data Security
                </h3>
                <p>
                  Except as described in this Policy, we do not disclose your personal information to third parties without your explicit consent, unless required to do so by applicable laws, court orders, or to protect our legal rights, property, and user safety.
                </p>
                <p>
                  We implement physical, managerial, and technical safeguards designed to protect the integrity and security of information we collect and maintain.
                </p>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  5. Contact Us Regarding Privacy
                </h3>
                <p>
                  If you have questions, feedback, or comments about this Privacy Policy, please contact our team:
                </p>
                <div
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "14px",
                    padding: "18px 20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:support@emibook.in" style={{ color: "#2563eb", textDecoration: "none" }}>
                      support@emibook.in
                    </a>{" "}
                    /{" "}
                    <a href="mailto:support@emibook.in" style={{ color: "#2563eb", textDecoration: "none" }}>
                      support@emibook.in
                    </a>
                  </div>
                  <div>
                    <strong>Phone:</strong>{" "}
                    <a href="tel:9036770772" style={{ color: "#2563eb", textDecoration: "none" }}>
                      +91 9036770772
                    </a>
                  </div>
                  <div>
                    <strong>Operating Entity:</strong> S R R Enterprise
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
